<div class="flex gap-2">
  <app-pan-button color="danger" icon="delete" (click)="params.removeCallback(params.data)" matTooltip="Remove Location Shrink"></app-pan-button>
</div>
